"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerProductsInnerVariantsInnerToJSON = exports.StoresInnerProductsInnerVariantsInnerFromJSONTyped = exports.StoresInnerProductsInnerVariantsInnerFromJSON = exports.instanceOfStoresInnerProductsInnerVariantsInner = void 0;
var runtime_1 = require("../runtime");
var StoresInnerProductsInnerVariantsInnerImagesInner_1 = require("./StoresInnerProductsInnerVariantsInnerImagesInner");
var StoresInnerProductsInnerVariantsInnerRgb_1 = require("./StoresInnerProductsInnerVariantsInnerRgb");
var StoresInnerProductsInnerVariantsInnerSizesInner_1 = require("./StoresInnerProductsInnerVariantsInnerSizesInner");
var StoresInnerProductsInnerVariantsInnerTrimRgb_1 = require("./StoresInnerProductsInnerVariantsInnerTrimRgb");
/**
 * Check if a given object implements the StoresInnerProductsInnerVariantsInner interface.
 */
function instanceOfStoresInnerProductsInnerVariantsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInnerProductsInnerVariantsInner = instanceOfStoresInnerProductsInnerVariantsInner;
function StoresInnerProductsInnerVariantsInnerFromJSON(json) {
    return StoresInnerProductsInnerVariantsInnerFromJSONTyped(json, false);
}
exports.StoresInnerProductsInnerVariantsInnerFromJSON = StoresInnerProductsInnerVariantsInnerFromJSON;
function StoresInnerProductsInnerVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'colorId': !(0, runtime_1.exists)(json, 'color_id') ? undefined : json['color_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'primaryImageUrl': !(0, runtime_1.exists)(json, 'primary_image_url') ? undefined : json['primary_image_url'],
        'rgb': !(0, runtime_1.exists)(json, 'rgb') ? undefined : (0, StoresInnerProductsInnerVariantsInnerRgb_1.StoresInnerProductsInnerVariantsInnerRgbFromJSON)(json['rgb']),
        'images': !(0, runtime_1.exists)(json, 'images') ? undefined : (json['images'].map(StoresInnerProductsInnerVariantsInnerImagesInner_1.StoresInnerProductsInnerVariantsInnerImagesInnerFromJSON)),
        'sizes': !(0, runtime_1.exists)(json, 'sizes') ? undefined : (json['sizes'].map(StoresInnerProductsInnerVariantsInnerSizesInner_1.StoresInnerProductsInnerVariantsInnerSizesInnerFromJSON)),
        'storeProductId': !(0, runtime_1.exists)(json, 'store_product_id') ? undefined : json['store_product_id'],
        'trimRgb': !(0, runtime_1.exists)(json, 'trim_rgb') ? undefined : (0, StoresInnerProductsInnerVariantsInnerTrimRgb_1.StoresInnerProductsInnerVariantsInnerTrimRgbFromJSON)(json['trim_rgb']),
    };
}
exports.StoresInnerProductsInnerVariantsInnerFromJSONTyped = StoresInnerProductsInnerVariantsInnerFromJSONTyped;
function StoresInnerProductsInnerVariantsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'color_id': value.colorId,
        'enabled': value.enabled,
        'primary_image_url': value.primaryImageUrl,
        'rgb': (0, StoresInnerProductsInnerVariantsInnerRgb_1.StoresInnerProductsInnerVariantsInnerRgbToJSON)(value.rgb),
        'images': value.images === undefined ? undefined : (value.images.map(StoresInnerProductsInnerVariantsInnerImagesInner_1.StoresInnerProductsInnerVariantsInnerImagesInnerToJSON)),
        'sizes': value.sizes === undefined ? undefined : (value.sizes.map(StoresInnerProductsInnerVariantsInnerSizesInner_1.StoresInnerProductsInnerVariantsInnerSizesInnerToJSON)),
        'store_product_id': value.storeProductId,
        'trim_rgb': (0, StoresInnerProductsInnerVariantsInnerTrimRgb_1.StoresInnerProductsInnerVariantsInnerTrimRgbToJSON)(value.trimRgb),
    };
}
exports.StoresInnerProductsInnerVariantsInnerToJSON = StoresInnerProductsInnerVariantsInnerToJSON;
